"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBucketWebsiteInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=GetBucketWebsiteInput.js.map